import "./index.scss";

const Spinner = () => (
  <div className="SpinnerOverlay">
    <div className="SpinnerContainer" />
  </div>
);

export default Spinner;
